import { Stack, Typography } from '@mui/material';
import { formatNumberToCurrency } from '@/utils/currency';
import { SummaryBar } from './SummaryBar';

export interface BarConfig {
  name: string;
  value: number;
  color: string;
  /**
   * Set for values the API reports as negative that should still render a
   * positive-length bar (e.g. losses). Unflagged negative values render no bar.
   */
  isNegative?: boolean;
}

interface CoolBarProps {
  barConfigs: BarConfig[];
}

/** Bars are scaled against the largest magnitude in the set. */
const getBarWidthPercentage = (barConfig: BarConfig, maxValue: number) => {
  const value = barConfig.isNegative ? -barConfig.value : barConfig.value;

  if (value <= 0 || maxValue <= 0) {
    return 0;
  }

  return Math.min((value / maxValue) * 100, 100);
};

export const CoolBars = ({ barConfigs }: CoolBarProps) => {
  const maxValue = Math.max(
    ...barConfigs.map((barConfig) => Math.abs(barConfig.value)),
  );

  return (
    <Stack
      direction='column'
      gap={2}
    >
      {barConfigs.map((barConfig) => (
        <Stack
          direction='column'
          gap={0.5}
          width='100%'
          key={barConfig.name}
        >
          <Typography variant='body2'>
            {`${barConfig.name}: ${formatNumberToCurrency(barConfig.value)}`}
          </Typography>

          <SummaryBar
            width={getBarWidthPercentage(barConfig, maxValue)}
            color={barConfig.color}
          />
        </Stack>
      ))}
    </Stack>
  );
};
